import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "dealer-invoice-detail-page" }
const _hoisted_2 = { class: "action-bar" }
const _hoisted_3 = { class: "section" }
const _hoisted_4 = { class: "collapse-icon" }
const _hoisted_5 = { class: "info-grid" }
const _hoisted_6 = { class: "info-item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "开票单名称", -1)
const _hoisted_8 = { class: "value" }
const _hoisted_9 = { class: "info-item" }
const _hoisted_10 = { class: "label" }
const _hoisted_11 = { class: "value" }
const _hoisted_12 = { class: "info-item" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "销售组织", -1)
const _hoisted_14 = { class: "value" }
const _hoisted_15 = { class: "info-item" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "经销商名称", -1)
const _hoisted_17 = { class: "value" }
const _hoisted_18 = { class: "info-item" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "ERP客户编码", -1)
const _hoisted_20 = { class: "value" }
const _hoisted_21 = {
  key: 0,
  class: "info-item"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "对账开始时间", -1)
const _hoisted_23 = { class: "value" }
const _hoisted_24 = {
  key: 1,
  class: "info-item"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "对账结束时间", -1)
const _hoisted_26 = { class: "value" }
const _hoisted_27 = { class: "info-item" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "开票总额", -1)
const _hoisted_29 = { class: "info-item" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "已开票金额", -1)
const _hoisted_31 = { class: "info-item" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "剩余可开金额", -1)
const _hoisted_33 = { class: "info-item" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "账单状态", -1)
const _hoisted_35 = { class: "value" }
const _hoisted_36 = { class: "section" }
const _hoisted_37 = { class: "collapse-icon" }
const _hoisted_38 = { class: "info-grid" }
const _hoisted_39 = { class: "info-item" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "经销商开票", -1)
const _hoisted_41 = { class: "value" }
const _hoisted_42 = { class: "info-item" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "开票类型", -1)
const _hoisted_44 = { class: "value" }
const _hoisted_45 = { class: "info-item" }
const _hoisted_46 = { class: "label" }
const _hoisted_47 = {
  key: 0,
  style: {"color":"#ff4d4f"}
}
const _hoisted_48 = { class: "value" }
const _hoisted_49 = { class: "info-item" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "发票抬头", -1)
const _hoisted_51 = { class: "value" }
const _hoisted_52 = { class: "info-item" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "纳税人识别号", -1)
const _hoisted_54 = { class: "value" }
const _hoisted_55 = { class: "info-item" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "开户银行", -1)
const _hoisted_57 = { class: "value" }
const _hoisted_58 = { class: "info-item" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "银行账号", -1)
const _hoisted_60 = { class: "value" }
const _hoisted_61 = { class: "info-item" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "开票电话", -1)
const _hoisted_63 = { class: "value" }
const _hoisted_64 = { class: "info-item" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "开票地址", -1)
const _hoisted_66 = { class: "value" }
const _hoisted_67 = { class: "info-item" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "寄送地址", -1)
const _hoisted_69 = { class: "value" }
const _hoisted_70 = { key: 1 }
const _hoisted_71 = { class: "info-item" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("span", { class: "label" }, "备注", -1)
const _hoisted_73 = { class: "value" }
const _hoisted_74 = { class: "section line-table-wrapper" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "section-title" }, "关联单据", -1)
const _hoisted_76 = { class: "vxe-table-container" }
const _hoisted_77 = ["href"]
const _hoisted_78 = { key: 1 }
const _hoisted_79 = {
  key: 0,
  style: {"color":"#ff4d4f"}
}
const _hoisted_80 = { key: 1 }
const _hoisted_81 = { class: "pagination-bar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oio_button = _resolveComponent("oio-button")!
  const _component_OioTag = _resolveComponent("OioTag")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_oio_input = _resolveComponent("oio-input")!
  const _component_oio_form_item = _resolveComponent("oio-form-item")!
  const _component_oio_form = _resolveComponent("oio-form")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_OioPagination = _resolveComponent("OioPagination")!
  const _component_oio_spin = _resolveComponent("oio-spin")!
  const _component_SpecifyInvoiceDialog = _resolveComponent("SpecifyInvoiceDialog")!
  const _component_OperationLogDialog = _resolveComponent("OperationLogDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_oio_spin, { loading: _ctx.loading }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (!_ctx.isDistributor && !_ctx.mode)
            ? (_openBlock(), _createBlock(_component_oio_button, {
                key: 0,
                danger: "",
                onClick: _ctx.handleConfirmBill
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 整单开票 ")
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true),
          (!_ctx.isDistributor && _ctx.isEditMode)
            ? (_openBlock(), _createBlock(_component_oio_button, {
                key: 1,
                type: "primary",
                onClick: _ctx.handlePartInvoice,
                disabled: _ctx.selectedLineKeys.length === 0
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 部分开票 ")
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]))
            : _createCommentVNode("", true),
          (!_ctx.isDistributor && _ctx.isEditMode)
            ? (_openBlock(), _createBlock(_component_oio_button, {
                key: 2,
                onClick: _ctx.handleSpecifyInvoice,
                disabled: _ctx.selectedLineKeys.length === 0 || !_ctx.allSelectedLinesSpecifiable
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 指定开票 ")
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]))
            : _createCommentVNode("", true),
          (!_ctx.isDistributor && _ctx.isIndependentBill)
            ? (_openBlock(), _createBlock(_component_oio_button, {
                key: 3,
                type: "primary",
                onClick: _ctx.handleRepack,
                disabled: !_ctx.hasRepackableLines
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 重新发起打包 ")
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]))
            : _createCommentVNode("", true),
          (!_ctx.isDistributor && _ctx.isIndependentBill && !_ctx.isEditMode)
            ? (_openBlock(), _createBlock(_component_oio_button, {
                key: 4,
                onClick: _ctx.handleSpecifyInvoice,
                disabled: _ctx.selectedLineKeys.length === 0 || !_ctx.allSelectedLinesSpecifiable
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 重新发起指定开票 ")
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]))
            : _createCommentVNode("", true),
          (!_ctx.isDistributor)
            ? (_openBlock(), _createBlock(_component_oio_button, {
                key: 5,
                danger: "",
                onClick: _ctx.handleCancelPack,
                disabled: !_ctx.hasCancelableLines
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 取消打包 ")
                ]),
                _: 1
              }, 8, ["onClick", "disabled"]))
            : _createCommentVNode("", true),
          _createVNode(_component_oio_button, {
            onClick: _ctx.handleDownloadInvoice,
            disabled: !_ctx.canDownloadInvoice(_ctx.billData.status)
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 下载发票 ")
            ]),
            _: 1
          }, 8, ["onClick", "disabled"]),
          _createVNode(_component_oio_button, { onClick: _ctx.handleExport }, {
            default: _withCtx(() => [
              _createTextVNode("导出明细")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_oio_button, { onClick: _ctx.handleLog }, {
            default: _withCtx(() => [
              _createTextVNode("操作日志")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_oio_button, { onClick: _ctx.fetchData }, {
            default: _withCtx(() => [
              _createTextVNode("刷新状态")
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: "section-title collapsible",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.basicInfoExpanded = !_ctx.basicInfoExpanded))
          }, [
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.basicInfoExpanded ? '▼' : '▶'), 1),
            _createTextVNode(" 基础信息 ")
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.billData.name || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.isIndependentBill ? '独立开票包编码' : '开票单编码'), 1),
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.billData.code || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.billData.salesOrgCode) + " " + _toDisplayString(_ctx.billData.salesOrgName), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.billData.distributorName || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.billData.distributorErpCode || '-'), 1)
            ]),
            (!_ctx.isIndependentBill)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.formatDate(_ctx.billData.accountStartDate)), 1)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isIndependentBill)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.formatDate(_ctx.billData.accountEndDate)), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("span", {
                class: _normalizeClass(["value", _ctx.getAmountClass(_ctx.billData.totalAmount)])
              }, _toDisplayString(_ctx.formatAmount(_ctx.billData.totalAmount)), 3)
            ]),
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("span", {
                class: _normalizeClass(["value", _ctx.getAmountClass(_ctx.billData.invoicedAmount)])
              }, _toDisplayString(_ctx.formatAmount(_ctx.billData.invoicedAmount)), 3)
            ]),
            _createElementVNode("div", _hoisted_31, [
              _hoisted_32,
              _createElementVNode("span", {
                class: _normalizeClass(["value", _ctx.getAmountClass(_ctx.billData.remainAmount)])
              }, _toDisplayString(_ctx.formatAmount(_ctx.billData.remainAmount)), 3)
            ]),
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("span", _hoisted_35, [
                _createVNode(_component_OioTag, {
                  color: _ctx.getBillStatusColor(_ctx.billData.status)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getBillStatusText(_ctx.billData.status)), 1)
                  ]),
                  _: 1
                }, 8, ["color"])
              ])
            ])
          ], 512), [
            [_vShow, _ctx.basicInfoExpanded]
          ])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("div", {
            class: "section-title collapsible",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.invoiceInfoExpanded = !_ctx.invoiceInfoExpanded))
          }, [
            _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.invoiceInfoExpanded ? '▼' : '▶'), 1),
            _createTextVNode(" 开票信息 ")
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _hoisted_40,
              _createElementVNode("span", _hoisted_41, [
                _createVNode(_component_a_select, {
                  value: _ctx.selectedInvoiceInfoId,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedInvoiceInfoId) = $event)),
                  placeholder: "客户信息（默认）",
                  style: {"width":"200px"},
                  class: "oio-select",
                  "dropdown-class-name": "oio-select-dropdown",
                  "show-search": "",
                  "filter-option": false,
                  onSearch: _ctx.handleInvoiceInfoSearch,
                  onChange: _ctx.handleInvoiceInfoChange,
                  disabled: !_ctx.invoiceInfoEditable,
                  "allow-clear": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: "default" }, {
                      default: _withCtx(() => [
                        _createTextVNode("客户信息（默认）")
                      ]),
                      _: 1
                    }),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredInvoiceInfoOptions, (info) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: info.id,
                        value: info.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(info.code) + " - " + _toDisplayString(info.invoiceTitle), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "onSearch", "onChange", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _createElementVNode("span", _hoisted_44, [
                _createVNode(_component_a_select, {
                  value: _ctx.editBillingType,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editBillingType) = $event)),
                  style: {"width":"180px"},
                  class: "oio-select",
                  "dropdown-class-name": "oio-select-dropdown",
                  disabled: !_ctx.invoiceInfoEditable
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableBillingTypes, (text, key) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: key,
                        value: key
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(text), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("span", _hoisted_46, [
                (_ctx.hasNegativePackLines)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_47, "*"))
                  : _createCommentVNode("", true),
                _createTextVNode("红字通知单号")
              ]),
              _createElementVNode("span", _hoisted_48, [
                _createVNode(_component_oio_input, {
                  value: _ctx.editNoticeInvoiceNo,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editNoticeInvoiceNo) = $event)),
                  placeholder: _ctx.hasNegativePackLines ? '存在负数单据，必填' : '无负数单据，不可填写',
                  style: {"width":"240px"},
                  disabled: !_ctx.invoiceInfoEditable || !_ctx.hasNegativePackLines
                }, null, 8, ["value", "placeholder", "disabled"])
              ])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _hoisted_50,
              _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.invoiceInfo.invoiceTitle || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_52, [
              _hoisted_53,
              _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.invoiceInfo.taxNo || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_55, [
              _hoisted_56,
              _createElementVNode("span", _hoisted_57, _toDisplayString(_ctx.invoiceInfo.bankName || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_58, [
              _hoisted_59,
              _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.invoiceInfo.bankAccount || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_61, [
              _hoisted_62,
              _createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.invoiceInfo.phone || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_64, [
              _hoisted_65,
              _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.invoiceInfo.address || '-'), 1)
            ]),
            _createElementVNode("div", _hoisted_67, [
              _hoisted_68,
              _createElementVNode("span", _hoisted_69, [
                (_ctx.isDefaultInvoiceInfo)
                  ? (_openBlock(), _createBlock(_component_oio_input, {
                      key: 0,
                      value: _ctx.editDeliveryAddress,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editDeliveryAddress) = $event)),
                      placeholder: "请填写发票邮寄地址",
                      style: {"width":"240px"},
                      disabled: !_ctx.invoiceInfoEditable
                    }, null, 8, ["value", "disabled"]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_70, _toDisplayString(_ctx.invoiceInfo.deliveryAddress || '-'), 1))
              ])
            ]),
            _createElementVNode("div", _hoisted_71, [
              _hoisted_72,
              _createElementVNode("span", _hoisted_73, [
                _createVNode(_component_oio_input, {
                  value: _ctx.editRemark,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.editRemark) = $event)),
                  placeholder: "备注",
                  style: {"width":"240px"},
                  disabled: !_ctx.invoiceInfoEditable
                }, null, 8, ["value", "disabled"])
              ])
            ])
          ], 512), [
            [_vShow, _ctx.invoiceInfoExpanded]
          ])
        ]),
        _createElementVNode("div", _hoisted_74, [
          _hoisted_75,
          _createVNode(_component_oio_form, {
            layout: "inline",
            data: _ctx.lineSearch,
            style: {"margin-bottom":"12px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_oio_form_item, { label: "分销渠道" }, {
                default: _withCtx(() => [
                  _createVNode(_component_oio_input, {
                    value: _ctx.lineSearch.distributionChannel,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.lineSearch.distributionChannel) = $event)),
                    placeholder: "分销渠道",
                    "allow-clear": "",
                    style: {"width":"120px"}
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_oio_form_item, { label: "80单号" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: _ctx.lineSearch.tmsOrderCode,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.lineSearch.tmsOrderCode) = $event)),
                    mode: "tags",
                    placeholder: "支持批量输入/粘贴",
                    "allow-clear": "",
                    style: {"width":"200px"},
                    class: "single-line-select",
                    "token-separators": [',', '，', ' ', '\n'],
                    open: false,
                    "suffix-icon": null
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_oio_form_item, { label: "90单号" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: _ctx.lineSearch.order90Code,
                    "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.lineSearch.order90Code) = $event)),
                    mode: "tags",
                    placeholder: "支持批量输入/粘贴",
                    "allow-clear": "",
                    style: {"width":"200px"},
                    class: "single-line-select",
                    "token-separators": [',', '，', ' ', '\n'],
                    open: false,
                    "suffix-icon": null
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_oio_form_item, { label: "开票状态" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_select, {
                    value: _ctx.lineSearch.status,
                    "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.lineSearch.status) = $event)),
                    placeholder: "全部",
                    "allow-clear": "",
                    style: {"width":"130px"},
                    class: "oio-select",
                    "dropdown-class-name": "oio-select-dropdown"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.billingLineStatusTextMap, (text, key) => {
                        return (_openBlock(), _createBlock(_component_a_select_option, {
                          key: key,
                          value: key
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(text), 1)
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_oio_form_item, { label: "数据包号" }, {
                default: _withCtx(() => [
                  _createVNode(_component_oio_input, {
                    value: _ctx.lineSearch.dataPackageNo,
                    "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.lineSearch.dataPackageNo) = $event)),
                    placeholder: "数据包号",
                    "allow-clear": "",
                    style: {"width":"150px"}
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_oio_form_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_oio_button, {
                    type: "primary",
                    onClick: _ctx.fetchLines
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("查询")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"]),
          _createElementVNode("div", _hoisted_76, [
            _createVNode(_component_vxe_table, {
              ref: "lineTableRef",
              border: "",
              "column-config": { resizable: true },
              height: "auto",
              "auto-resize": "",
              size: "small",
              "show-overflow": "",
              "show-header-overflow": "",
              data: _ctx.lineData,
              loading: _ctx.lineLoading,
              "scroll-x": { enabled: true },
              "scroll-y": { enabled: true, gt: 0 },
              "checkbox-config": { highlight: true },
              "row-config": { isCurrent: true, isHover: true },
              onCheckboxChange: _ctx.onLineCheckboxChange,
              onCheckboxAll: _ctx.onLineCheckboxChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_vxe_column, {
                  type: "checkbox",
                  width: "50",
                  fixed: "left",
                  align: "center"
                }),
                _createVNode(_component_vxe_column, {
                  field: "tmsOrderCode",
                  title: "80单号",
                  width: "120"
                }),
                _createVNode(_component_vxe_column, {
                  field: "order90Code",
                  title: "90单号",
                  width: "120"
                }),
                _createVNode(_component_vxe_column, {
                  field: "deliveryOrderCode",
                  title: "交货单号",
                  width: "120"
                }),
                _createVNode(_component_vxe_column, {
                  field: "invoiceNo",
                  title: "发票号",
                  width: "120"
                }),
                _createVNode(_component_vxe_column, {
                  field: "distributionChannel",
                  title: "分销渠道",
                  width: "100"
                }),
                _createVNode(_component_vxe_column, {
                  field: "taxInclusiveAmount",
                  title: "含税净额",
                  width: "110",
                  align: "right"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.getAmountClass(row.taxInclusiveAmount))
                    }, _toDisplayString(_ctx.formatAmount(row.taxInclusiveAmount)), 3)
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "billingNetAmount",
                  title: "行不含税净额",
                  width: "120",
                  align: "right"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.getAmountClass(row.billingNetAmount))
                    }, _toDisplayString(_ctx.formatAmount(row.billingNetAmount)), 3)
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "billingTaxAmount",
                  title: "单行销项税额",
                  width: "120",
                  align: "right"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.getAmountClass(row.billingTaxAmount))
                    }, _toDisplayString(_ctx.formatAmount(row.billingTaxAmount)), 3)
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "lineAmount",
                  title: "行金额",
                  width: "110",
                  align: "right"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.getAmountClass(row.lineAmount))
                    }, _toDisplayString(_ctx.formatAmount(row.lineAmount)), 3)
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "profitCenter",
                  title: "利润中心",
                  width: "100"
                }),
                _createVNode(_component_vxe_column, {
                  field: "companyCode",
                  title: "公司代码",
                  width: "90"
                }),
                _createVNode(_component_vxe_column, {
                  field: "payer",
                  title: "付款方",
                  width: "100"
                }),
                _createVNode(_component_vxe_column, {
                  field: "status",
                  title: "开票状态",
                  width: "100",
                  fixed: "right"
                }, {
                  default: _withCtx(({ row }) => [
                    _createVNode(_component_OioTag, {
                      color: _ctx.getLineStatusColor(row.status)
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.getLineStatusText(row.status)), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "dataPackageNo",
                  title: "数据包号",
                  width: "140"
                }),
                _createVNode(_component_vxe_column, {
                  field: "mainPackageNo",
                  title: "主包号",
                  width: "140"
                }),
                _createVNode(_component_vxe_column, {
                  field: "vatInvoiceNo",
                  title: "增票号",
                  width: "120"
                }),
                _createVNode(_component_vxe_column, {
                  field: "invoiceFileUrl",
                  title: "发票文件",
                  width: "80",
                  align: "center"
                }, {
                  default: _withCtx(({ row }) => [
                    (row.invoiceFileUrl)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: row.invoiceFileUrl,
                          target: "_blank"
                        }, "下载", 8, _hoisted_77))
                      : (_openBlock(), _createElementBlock("span", _hoisted_78, "-"))
                  ]),
                  _: 1
                }),
                _createVNode(_component_vxe_column, {
                  field: "errorMsg",
                  title: "错误信息",
                  width: "150"
                }, {
                  default: _withCtx(({ row }) => [
                    (row.errorMsg)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_79, _toDisplayString(row.errorMsg), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_80, "-"))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data", "loading", "onCheckboxChange", "onCheckboxAll"])
          ]),
          _createElementVNode("div", _hoisted_81, [
            _createVNode(_component_OioPagination, {
              currentPage: _ctx.linePagination.current,
              pageSize: _ctx.linePagination.pageSize,
              total: _ctx.linePagination.total,
              showTotal: "",
              showJumper: "",
              onChange: _ctx.handleLinePaginationChange
            }, null, 8, ["currentPage", "pageSize", "total", "onChange"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["loading"]),
    _createVNode(_component_SpecifyInvoiceDialog, {
      visible: _ctx.showSpecifyDialog,
      "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.showSpecifyDialog) = $event)),
      "selected-lines": _ctx.selectedLines,
      "billing-bill": _ctx.billData,
      "invoice-selection": _ctx.invoiceSelectionPayload,
      onSuccess: _ctx.fetchData
    }, null, 8, ["visible", "selected-lines", "billing-bill", "invoice-selection", "onSuccess"]),
    _createVNode(_component_OperationLogDialog, {
      visible: _ctx.logVisible,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.logVisible) = $event)),
      "billing-bill": _ctx.billData
    }, null, 8, ["visible", "billing-bill"])
  ]))
}